import React from 'react';
import { isTacticStaffOrImpersonated, showRecurring } from '@/lib/featureFlags';
import { ReserveFormRecurringSelector } from '@/components/reserve/Reserve/controls/ReserveFormRecurringSelector';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';
import { useAuthenticated } from '@gettactic/hooks';

export const ReserveFormRecurring: React.FC<{ isCompact?: boolean }> = ({
  isCompact = false
}) => {
  const { resourceType, selectedOffice } = useReserveForm();
  const {
    userContext: { authenticatedUser, currentOffice }
  } = useAuthenticated();
  return (
    <div className="text-left">
      {!showRecurring(resourceType, authenticatedUser, selectedOffice) &&
      isTacticStaffOrImpersonated(authenticatedUser) ? (
        <p className="text-red-500">Recurring visible due to impersonation:</p>
      ) : null}
      {showRecurring(resourceType, authenticatedUser, selectedOffice) ||
      isTacticStaffOrImpersonated(authenticatedUser) ? (
        <ReserveFormRecurringSelector isCompact={isCompact} />
      ) : null}
    </div>
  );
};
